
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { FormItemProps } from ".";
import { loading, find } from "store/form";

interface ApiFormFindByIdInputProps {
    id: number;
}

type ApiFormFindOutputProps = OutputBaseProps<{ item: FormItemProps; }, ApiFormFindByIdInputProps>

export const apiFormFindById = async (data: ApiFormFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiFormFindOutputProps>(`/api/form/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};


interface ApiFormFindByCodeInputProps {
    code: string;
}

export const apiFormFindByCode = async (data: ApiFormFindByCodeInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiFormFindOutputProps>(`/api/form/code/${data.code}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};